export const CreditRatings = {
	RATED_INVESTMENT_GRADE: 'Rated - Investment grade',
	RATED_SUB_INVESTMENT_GRADE: 'Rated - Sub-investment grade',
	UNRATED_INVESTMENT_GRADE_EQUIVALENT: 'Unrated - Investment grade equivalent',
	UNRATED_SUB_INVESTMENT_GRADE_EQUIVALENT: 'Unrated - Sub-investment grade equivalent',
};

export const CreditRatingOptions = [
	CreditRatings.RATED_INVESTMENT_GRADE,
	CreditRatings.RATED_SUB_INVESTMENT_GRADE,
	CreditRatings.UNRATED_INVESTMENT_GRADE_EQUIVALENT,
	CreditRatings.UNRATED_SUB_INVESTMENT_GRADE_EQUIVALENT,
].map(rating => ({ key: rating, text: rating, value: rating }));
